<template>
  <div class="app">
    <el-container>
      <el-header>
        <span>免费SSR/V2ray节点</span>
        <span>-</span>
        <span>free.darrenliuwei.com</span>
      </el-header>

      <div class="w ads">
        <div>
          <!-- free-ssr -->
          <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-7115184053783576" data-ad-slot="3380211071" data-ad-format="auto" data-full-width-responsive="true"></ins>
        </div>
      </div>

      <el-main class="w">
        <div class="content">
          <!-- 免费SSR节点列表 -->
          <!-- <div class="nodes">
            <h4>免费SSR节点列表：</h4>
            <ul>
              <li v-for="item in ssrList" :key="item.id">
                <span>{{ item.name }}</span>
                <el-button type="success" plain @click="copySsr(item.name, item.url)">复制SSR链接</el-button>
              </li>
            </ul>
            <el-button type="primary" round @click="copyAllSsr">复制所有SSR节点</el-button>
          </div>
          <div class="space"></div> -->
          <div class="vultr">
            <a href="https://www.vultr.com/?ref=8371895-6G" target="_blank">
              <img src="@/assets/images/vultr.png" alt="Vultr云服务器" />
            </a>
          </div>
        
          <div class="space"></div>

          <!-- 免费V2ray节点列表 -->
          <div class="nodes">
            <h4>免费V2ray节点列表：</h4>
            <ul>
              <li v-for="item in v2rayList" :key="item.id">
                <span>{{ item.name }}</span>
                <el-button type="primary" plain @click="copyV2ray(item.name, item.url)">复制V2ray链接</el-button>
              </li>
            </ul>
            <el-button type="success" round @click="copyAllV2ray">复制所有V2ray节点</el-button>
          </div>

          <div class="space"></div>

          <div class="vultr">
            <a href="https://www.vultr.com/?ref=8371895-6G" target="_blank">
              <img src="@/assets/images/vultr.webp" alt="Vultr云服务器" />
            </a>
          </div>

          <div class="space"></div>
          <!-- 本站注意事项 -->
          <el-card class="box-card">
            <div class="card-title">
              <span>常见问题 - free.darrenliuwei.com</span>
            </div>
            <el-collapse v-model="activeNames">
              <el-collapse-item title="为什么更新？没有订阅？" name="1">
                <div>1、更新端口密码，避免大流量高频率导致服务器被屏蔽。</div>
                <div>2、防止长时间人数积累，导致节点不可使用。</div>
                <div>3、free.darrenliuwei.com没有订阅，本站是唯一更新渠道。</div>
              </el-collapse-item>
              <el-collapse-item title="免费节点适合我吗？" name="2">
                <div>偶尔：上网查资料访问文字内容站点免费节点勉强应对。</div>
                <div>经常：图片视频观看等对网速带宽有要求最好购买机场服务(可在本站赞助商中选择)。</div>
                <div>刚需：有重要的个人账户和业务，请自建节点并以机场作为备用。</div>
                <div>free.darrenliuwei.com不建议长期使用免费节点，哪怕free.darrenliuwei.com本身做这个。</div>
              </el-collapse-item>
              <el-collapse-item title="关于留言" name="3">
                <div>1、在留言之前，请先看一下网站上的节点更新记录，看看自己是否已更新到最新的节点信息。</div>
                <div>2、留言内容要具体一点，例如：SSR: 日本1 、韩国2 节点用不了了，V2ray: 日本2、韩国9 节点用不了了等等。</div>
                <div>3、留言内容一定要具体一点，说话不要拐弯抹角。</div>
              </el-collapse-item>
            </el-collapse>
          </el-card>
          <div class="space"></div>
          <!-- 用户留言 -->
          <div class="discuss">
            <p>
              如果哪个SSR或者V2ray节点用不了了，就留言，我收到邮件就会第一时间进行修复
            </p>
            <el-alert title="恭喜留言成功，等待管理员审核，审核通过之后，将会在下面留言列表里显示。" type="success" show-icon v-show="commentFlag === 2" @close="closeInput"></el-alert>
            <el-alert title="很遗憾，留言失败！" type="error" show-icon v-show="commentFlag === 3" @close="closeInput"></el-alert>
            <el-form ref="form" label-width="80px">
              <el-form-item label="昵称：">
                <el-input aria-required type="text" placeholder="请输入昵称" v-model="commentData.nickname"></el-input>
              </el-form-item>
              <el-form-item label="留言框：">
                <el-input type="textarea" placeholder="请输入留言" v-model="commentData.content"></el-input>
              </el-form-item>
              <div class="btn">
                <el-button @click="resetComment">重置留言</el-button>
                <el-button type="primary" @click="doComment">发表留言</el-button>
              </div>
            </el-form>
          </div>
          <div class="space"></div>
          <!-- 留言列表 -->
          <div class="discuss-list">
            <ul>
              <li v-for="item in discussList.data" :key="item.id">
                <p>留言：{{ item.content }}</p>
                <span>昵称：{{ item.nickname }}</span>
                <span>时间：{{ item.create_time }}</span>
              </li>
            </ul>
          </div>
          <div class="space"></div>
          <!-- 留言板-分页 -->
          <el-pagination background layout="prev, pager, next, total" :total="discussList.total" :page-size="8" @current-change="changePage"></el-pagination>
        </div>

        <div class="side">
          <!-- SSR客户端软件下载 -->
          <div class="client">
            <h3>SSR客户端软件下载</h3>
            <div class="soft">
              <el-link type="primary" href="https://github.com/shadowsocksrr/electron-ssr/releases" target="_blank">Linux</el-link>
              <el-link type="danger" href="https://github.com/qinyuhang/ShadowsocksX-NG-R/releases" target="_blank">Mac</el-link>
              <el-link type="success" href="https://github.com/shadowsocksr-backup/shadowsocksr-csharp/releases" target="_blank">Windows</el-link>
              <el-link type="warning" href="https://github.com/shadowsocksr-backup/shadowsocksr-android/releases" target="_blank">Android</el-link>
            </div>
          </div>
          <div class="space"></div>
          <!-- V2ray客户端软件下载 -->
          <div class="client">
            <h3>V2ray客户端软件下载</h3>
            <div class="soft">
              <el-link type="primary" href="https://github.com/Qv2ray/Qv2ray/releases" target="_blank">Linux</el-link>
              <el-link type="danger" href="https://github.com/yanue/V2rayU/releases" target="_blank">Mac</el-link>
              <el-link type="success" href="https://github.com/2dust/v2rayN/releases" target="_blank">Windows</el-link>
              <el-link type="warning" href="https://github.com/2dust/v2rayNG/releases" target="_blank">Android</el-link>
            </div>
          </div>
          <div class="space"></div>
          <!-- Telegram交流群 -->
          <div class="client">
            <h3>Telegram交流群</h3>
            <div class="soft">
              <el-link type="info" href="https://t.me/sphard" target="_blank">https://t.me/sphard</el-link>
            </div>
          </div>
          <!-- justmysocks搬瓦工机场广告栏 -->
          <div class="side-ad">
            <a href="https://justmysocks3.net/members/aff.php?aff=5504" target="_blank">
              <img src="@/assets/images/JustMySocks.jpg" alt="JustMySocks优质机场" />
            </a>
          </div>
          <!-- SSR更新信息 -->
          <div class="ssr-update">
            <el-timeline>
              <el-timeline-item v-for="item in ssrUpdateInfo.data" :key="item.id" :timestamp="item.create_time">{{ item.content }}</el-timeline-item>
            </el-timeline>
            <el-pagination background layout="pager" :total="ssrUpdateInfo.total" :pager-count="5" @current-change="UpdateSsrPage"></el-pagination>
          </div>
        </div>
      </el-main>

      <!-- 网站底部信息区 -->
      <footer>
        <p>
          建议/反馈：
          <span>ghdhsetyhthdf537@gmail.com</span>
        </p>
      </footer>
    </el-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import useClipboard from 'vue-clipboard3'
import { ElMessage } from 'element-plus'
import { getAllSsr, getUpdateSsr } from '@/api/ssr'
import { getAllV2ray } from '@/api/v2ray'
import { newDiscuss, allDiscuss } from '@/api/discuss'

export default defineComponent({
  setup() {
    const { toClipboard } = useClipboard()

    const copy = async (text: string) => {
      try {
        await toClipboard(text)
      } catch (e) {
        console.error(e)
      }
    }

    return { copy }
  },
  data() {
    return {
      activeNames: ['1'],
      // 所有ssr节点
      ssrList: [],
      // 所有v2ray节点
      v2rayList: [],
      // 判断用户是否留言成功，1为隐藏，2为成功，3为失败
      commentFlag: 1,
      // 用户留言信息
      commentData: {
        nickname: '', // 用户昵称
        content: '' // 用户留言内容
      },
      // 用户留言列表
      discussList: {},
      // ssr/v2ray节点更新记录
      ssrUpdateInfo: {}
    }
  },
  created() {
    // 获取所有ssr节点
    this.fetchSsrList()
    // 获取所有v2ray节点
    this.fetchV2rayList()
    // 获取所有留言
    this.fetchAllDiscuss(1)
    // 获取所有节点更新信息
    this.fetchSsrUpdates(1)
  },
  methods: {
    // 获取所有ssr节点
    async fetchSsrList() {
      const res = await getAllSsr()
      this.ssrList = res
    },
    // 复制SSR链接
    copySsr(name: string, url: string) {
      url = url?.slice(0, 15) + '' + url?.slice(16)
      this.copy(url)
      ElMessage.success('恭喜您，复制 ' + name + ' SSR节点成功！')
    },
    // 复制所有SSR节点
    copyAllSsr() {
      let text = ''
      this.ssrList.forEach((item: any) => {
        item.url = item?.url?.slice(0, 15) + '' + item?.url?.slice(16)
        text += item.url + '\n'
      })
      this.copy(text)
      ElMessage.success('恭喜您，复制所有SSR节点成功！')
    },
    // 获取所有v2ray节点
    async fetchV2rayList() {
      const res = await getAllV2ray()
      this.v2rayList = res
    },
    // 复制V2ray链接
    copyV2ray(name: string, url: string) {
      url = url?.slice(0, 15) + '' + url?.slice(16)
      this.copy(url)
      ElMessage.success('恭喜您，复制 ' + name + ' V2ray节点成功！')
    },
    // 复制所有V2ray节点
    copyAllV2ray() {
      let text = ''
      this.v2rayList.forEach((item: any) => {
        item.url = item?.url?.slice(0, 15) + '' + item?.url?.slice(16)
        text += item.url + '\n'
      })
      this.copy(text)
      ElMessage.success('恭喜您，复制所有V2ray节点成功！')
    },
    // 关闭留言提示框，然后让是否显示留言提示框恢复初始值，并隐藏
    closeInput() {
      this.commentFlag = 1
    },
    // 重置留言
    resetComment() {
      this.commentData.nickname = ''
      this.commentData.content = ''
    },
    // 发表留言
    async doComment() {
      if (this.commentData.nickname.length === 0) {
        this.commentFlag = 3
        ElMessage.error('请输入用户昵称')
      } else if (this.commentData.content.length === 0) {
        this.commentFlag = 3
        ElMessage.error('请输入留言内容')
      } else {
        const res = await newDiscuss(this.commentData)
        this.commentData.nickname = ''
        this.commentData.content = ''
        // 判断留言是否成功
        if (res.code === 1) {
          this.commentFlag = 2
        } else {
          this.commentFlag = 3
        }
      }
    },
    // 获取所有留言
    async fetchAllDiscuss(pageNum: number) {
      const res = await allDiscuss(pageNum)
      this.discussList = res
    },
    // 留言板分页
    async changePage(pageNum: number) {
      this.fetchAllDiscuss(pageNum)
    },
    // 获取所有SSR更新信息
    async fetchSsrUpdates(pageNum: number) {
      const res = await getUpdateSsr(pageNum)
      this.ssrUpdateInfo = res
    },
    // ssr更新记录分页
    async UpdateSsrPage(pageNum: number) {
      this.fetchSsrUpdates(pageNum)
    }
  }
})
</script>
<style lang="scss" scoped>
.app {
  background-color: #f3f3f3;

  img {
    width: 100%;
    height: 100%;
  }

  .space {
    height: 15px;
  }

  .ads {
    width: 90%;
    max-width: 1400px;
    margin: 15px auto;
    height: 100px;
  }

  .el-header {
    box-shadow: 0 5px 10px 0 #ddd;
    width: 100%;
    height: 60px;
    line-height: 60px;
    background-color: #fff;
    font-size: 20px;
    padding-left: 12vw;

    span:nth-child(1) {
      color: red;
    }
    span:nth-child(2) {
      color: grey;
    }
    span:nth-child(3) {
      color: blue;
    }
  }

  .el-main {
    display: flex;
    flex-direction: row;
    width: 90%;
    max-width: 1400px;
    margin: auto;
    padding: 0;

    .content {
      flex: 1;

      .vultr {
        width: 100%;
        height: 100px;
      }

      .nodes {
        position: relative;
        padding: 10px 10px 60px;
        background-color: #fff;

        h4 {
          margin: 5px 0 0 5px;
        }

        ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          margin-bottom: 8px;

          li {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 10px 10px 15px;
            width: 20%;
            height: 65px;
            margin-top: 15px;
            border: 1px solid #ccc;
            text-align: center;
            border-radius: 10px;
            box-shadow: 5px 4px 5px #f3f3f3;
          }
        }

        > button {
          position: absolute;
          right: 15px;
          bottom: 15px;
        }
      }

      .el-card {
        .card-title {
          margin-bottom: 15px;
          color: red;
        }
      }

      .discuss {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 15px 0;
        background-color: #fff;

        p {
          margin-bottom: 8px;
          color: #ff0000;
          font-size: 19px;
        }

        .el-alert {
          width: 80%;
          margin-bottom: 10px;
        }

        .el-form {
          .btn {
            display: flex;
            justify-content: space-around;
          }

          .el-form-item {
            width: 630px;
          }
        }
      }

      .discuss-list {
        width: 100%;
        background-color: #fff;

        ul {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 15px 0;

          li {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 10px;
            width: 90%;
            margin-top: 10px;
            border: 1px solid #ccc;
            border-radius: 10px;
            box-shadow: 2px 2px 1px pink;

            &:nth-child(1) {
              margin-top: 0;
            }

            span {
              &:nth-child(2) {
                color: #ccc;
              }
              &:nth-child(3) {
                color: blue;
                font-size: 14px;
              }
            }
          }
        }
      }
    }

    .side {
      width: 290px;
      min-width: 200px;
      margin-left: 20px;
      overflow: hidden;

      .client {
        width: 100%;
        padding: 10px 0;
        text-align: center;
        background-color: #fff;

        h3 {
          margin-bottom: 10px;
        }

        .soft {
          display: flex;
          justify-content: space-around;
          align-items: center;
        }
      }

      .side-ad {
        width: 100%;
        height: 200px;
        margin-top: 15px;
      }

      .ssr-update {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 15px;
        padding: 20px 5px;
        box-sizing: border-box;
        background-color: #fff;
      }
    }
  }

  footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
    margin-top: 15px;
    background-color: #3a3a3a;
    font-size: 17px;
    color: #fff;

    span {
      font-size: 28px;
    }
  }
}
</style>
